import notificationTypes from '../../config/notificationTypes'

import getLabels from '../getLabels'
import generateUniqueId from '../generateUniqueId'
import buildCustomNotification from './buildCustomNotification'

const errorCode = 'error_age_less_than_two'
const fieldName = 'DateOfBirth'

export default (passengerId: string) =>
  buildCustomNotification({
    id: generateUniqueId(),
    type: notificationTypes.warning,
    message: getLabels(errorCode),
    code: `[${errorCode}]`,
    isGlobal: false,
    passengerId,
    isInfant: false,
    fieldName,
  })
